import { channelStore } from '../../app/stores'
import { mapValues } from '../../lib'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Prompt } from 'react-router'
import AutoMessage from './AutoMessage'
import AutoMessageAdd from './AutoMessageAdd'
import AutoMessageForm from './AutoMessageForm'

const NEW_AUTO_MESSAGE = 'NEW_AUTO_MESSAGE'

class AutoMessageList extends Component {
  constructor (props) {
    super(props)
    this.handleEditing = this.handleEditing.bind(this)
    this.clearEditing = this.clearEditing.bind(this)
    this.state = { editing: null }
  }

  handleEditing (editing) {
    this.setState({ editing })
  }

  clearEditing () {
    this.setState({ editing: null })
  }

  render () {
    return (
      <div className='AutoMessageList'>
        <Prompt
          when={this.state.editing === NEW_AUTO_MESSAGE}
          message='You haven’t saved your Auto Message. Are you sure you want to leave?'
        />
        {this.state.editing === NEW_AUTO_MESSAGE ? (
          <AutoMessageForm
            onClose={this.clearEditing}
            onSubmit={fieldsData => {
              const values = mapValues(fieldsData)
              return channelStore.addAutoMessage(values)
            }}
            onSubmitSuccess={this.clearEditing}
            prompt='Create'
          />
        ) : (
          <AutoMessageAdd
            onAdd={() => this.handleEditing(NEW_AUTO_MESSAGE)}
          />
        )}
        {channelStore.autoMessages.map(autoMessage => (
          <AutoMessage
            key={autoMessage.key}
            autoMessage={autoMessage}
            onEdit={this.handleEditing}
            onClose={this.clearEditing}
            editing={this.state.editing === autoMessage.key}
          />
        ))}
      </div>
    )
  }
}

AutoMessageList.displayName = 'AutoMessageList'

export default observer(AutoMessageList)



// WEBPACK FOOTER //
// ./src/channel/automessages/AutoMessageList.js